import React from "react";
export const ShippingWidget = ({ missingAmount, amountNeeded }) => {
    return (React.createElement("div", { className: "flex flex-col items-center justify-center p-4" },
        missingAmount > 0 ?
            React.createElement("div", { className: "flex items-center justify-center font-sans text-sm" },
                React.createElement("div", { className: "text-vital-brand-blue text-sm font-abc-monument-grotesk font-medium leading-[inherit]" },
                    "Add $",
                    missingAmount.toFixed(2)),
                "\u00A0to unlock Free Shipping!")
            :
                React.createElement("div", { className: "text-vital-brand-blue font-abc-monument-grotesk text-sm font-medium font-sans" }, "You've got Free Shipping!"),
        React.createElement("div", { className: "w-full h-[4px] bg-[#D8D8D8] rounded mt-2" },
            React.createElement("div", { className: "h-[4px] bg-vital-brand-blue rounded", style: { width: missingAmount <= 0 ? "100%" : `${((amountNeeded - missingAmount) / amountNeeded * 100).toFixed(2)}%` } }))));
};
